import { useWLoading } from '@pequity/shared/ui';
import { type Router } from 'vue-router';

export const displayWLoading = (router: Router) => {
  const { loadingShow, loadingHide } = useWLoading();

  router.beforeEach((to, from, next) => {
    // Hide the loading indicator in case it was already displayed
    loadingHide('routeChange');

    // If this isn't an initial page load, display the loading indicator
    if (from.name) {
      loadingShow({ id: 'routeChange' });
    }

    next();
  });

  router.afterEach(() => {
    loadingHide('routeChange');
  });
};
